<app-training-obligation-hero></app-training-obligation-hero>

<app-training-orientation (tracker)="onTrackerClicked($event)"></app-training-orientation>

<section role="region" class="wrapper--light">
  <div class="training-obligation__build-future">
    <h2 class="training-obligation__build-future__title">
      <span class="line-break"> Pour que chaque jeune construise son avenir, </span>
      <span class="highlight--emphasis"> mettons toutes les chances de son côté. </span>
    </h2>
    <div class="training-obligation__build-future__content">
      <div class="training-obligation__build-future__content_description">
        <p>
          Depuis la rentrée 2020, afin qu&apos;aucun d&apos;entre vous ne soit laissé dans une situation où vous ne
          seriez ni en études, ni en formation, ni en emploi,
          <strong> l&apos;obligation de se former est prolongée jusqu&apos;à l&apos;âge de 18 ans. </strong>
        </p>
        <p>
          <strong>L&apos;obligation de formation</strong> – qui a été créée par la loi du 26 juillet 2019 « Pour une
          école de la confiance » –
          <strong>
            est une des mesures clé de la stratégie de prévention et de lutte contre la pauvreté du Gouvernement
          </strong>
          et qui permet de vous amener vers un parcours d&apos;accompagnement et de formation lorsque vous êtes en
          risque d&apos;exclusion. Elle prend le relais de l&apos;obligation d&apos;instruction de 3 à 16 ans.
        </p>

        <a
          href="https://www.education.gouv.fr/l-obligation-de-formation-des-16-18-ans-306954"
          target="_blank"
          class="btn btn-clean training-obligation__build-future__content_link"
          (click)="onTrackerClicked('Discover')"
          >Découvrir la mesure
        </a>
      </div>
      <div
        class="training-obligation__build-future__content_illustration"
        [style.backgroundImage]="illustrationSrc"
      ></div>
    </div>
  </div>
</section>

<section role="region">
  <div class="training-obligation__engagement">
    <h2>Tous les acteurs mobilisés, ensemble</h2>
    <p>
      Tous les acteurs de l&apos;éducation, de l&apos;insertion sociale et professionnelle travaillent ensemble à ce que
      chacun d&apos;entre vous trouve sa place. Les professionnels des Missions locales ou du Centre d&apos;Information
      et d&apos;Orientation de proximité travaillent en lien étroit avec tous les acteurs&nbsp;:&nbsp;établissements
      scolaires, centres d&apos;information et d&apos;orientation, Pôle emploi, structures de raccrochage scolaire
      (micro-lycées), écoles de la 2e chance, etc.
    </p>
  </div>
</section>
